import ReactGA from 'react-ga4';
import { Result } from '@hitiq/generic';
import { Logger, LogType } from '@hitiq/logger';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';
import { ModelTypes } from '../../dataStorePersistence/DataStoreModel';
import { Persistance } from '../../dataStorePersistence/persistence';
import { Translator } from '../translator.interface';
import { Player, PlayerBackend } from './player.interfaces';

export const createPlayerThunk = createAsyncThunk(
  'player/createPlayer',
  async (
    payload: {
      translator: Translator<PlayerBackend, Player>;
      persistence: Persistance<PlayerBackend>;
      loggingService: Logger;
      resource: Player;
    },
    thunkAPI,
  ): Promise<any> => {
    const { persistence, translator, resource, loggingService } = payload;

    const player = newPlayer(resource);
    const backendResource = translator.translateOneToBackendModel(player);

    const result: Result<PlayerBackend> = await persistence.create(
      backendResource,
    );
    loggingService.log(LogType.info, `Player: ${result.data.id} created.`);

    if (result.error) {
      loggingService.log(
        LogType.error,
        `Player: creation failed: ${result.error}`,
      );
      return onError(thunkAPI, result.error);
    }

    ReactGA.event({
      category: 'Player',
      action: 'Create',
    });

    // WARNING: don't use response in redux since onCreate will do this.
    return result.data.id;
  },
);

function newPlayer(resource: Player): Player {
  return {
    id: 'not empty',
    modelType: ModelTypes.Player,
    createdByUserId: resource.createdByUserId,
    firstName: resource.firstName,
    lastName: resource.lastName,
    dateOfBirth: resource.dateOfBirth,
    // guardianEmail: resource.guardianEmail,
    accountId: resource.accountId,
    clearedToPlay: true,
  };
}

function onError(thunkAPI: any, error: Error) {
  return thunkAPI.rejectWithValue({
    heading: 'Unable to create player',
    message: error.message,
    severity: 'error',
    id: uuidv4(),
  });
}
